import { render, staticRenderFns } from "./RegistPassword.vue?vue&type=template&id=d94a4ef4&scoped=true&lang=pug&"
import script from "./RegistPassword.vue?vue&type=script&lang=ts&"
export * from "./RegistPassword.vue?vue&type=script&lang=ts&"
import style0 from "./RegistPassword.vue?vue&type=style&index=0&id=d94a4ef4&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94a4ef4",
  null
  
)

export default component.exports